<template>
  <div class="comment-input">
    <input
      type="text"
      :placeholder="placeholder"
      v-model.trim="contentLocal"
      @keyup.enter="handleSubmit"
      ref="input"
    />
    <div class="comment-actions">
      <button :disabled="!contentLocal" @click="handleSubmit">{{ submitText }}</button>
      <button @click="$emit('cancel')">キャンセル</button>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      type: String,
      default: ''
    },
    mode: {
      type: String,
      default: 'create'
    },
    placeholder: {
      type: String,
      default: 'コメントする...'
    },
    submitText: {
      type: String,
      default: 'コメント'
    },
    autoFocus: {
      type: Boolean,
      default: false
    }
  },
  emits: ['submit', 'cancel', 'input'],
  data () {
    return {
      contentLocal: this.value
    }
  },
  mounted () {
    if (this.autoFocus) {
      this.$nextTick(() => {
        this.$refs.input.focus()
      })
    }
  },
  watch: {
    value (val) {
      this.contentLocal = val
    },
    contentLocal (val) {
      this.$emit('input', val)
    }
  },
  methods: {
    handleSubmit () {
      if (!this.contentLocal.trim()) return
      this.$emit('submit', this.contentLocal)
    }
  }
}
</script>

<style scoped>
.comment-input {
  margin-top: 10px;
}
.comment-input input {
  width: 100%;
  padding: 10px;
  font-size: 14px;
  border: 1px solid #ccc;
  border-radius: 20px;
  outline: none;
}
.comment-actions {
  margin-top: 8px;
  display: flex;
  justify-content: end;
  gap: 10px;
}
.comment-actions button {
  background-color: #f1f1f1;
  border: none;
  padding: 6px 12px;
  border-radius: 12px;
  cursor: pointer;
}
.comment-actions button:disabled {
  opacity: 0.5;
  cursor: default;
}
</style>



// WEBPACK FOOTER //
// src/view/video/components/CommentInput.vue